import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { CalendarEventType } from 'src/app/models/calendar-event-type';
import { CalendarFilter } from 'src/app/models/calendar-filter';
import { Country } from 'src/app/models/country';
import { CalendarService } from 'src/app/services/calendar/calendar.service';
import { CountryService } from 'src/app/services/country/country.service';
import { CalendarFilterPopupComponent } from '../calendar-filter-popup/calendar-filter-popup.component';

@Component({
  selector: 'app-calendar-filter',
  templateUrl: './calendar-filter.component.html',
  styleUrls: ['./calendar-filter.component.scss'],
})
export class CalendarFilterComponent implements OnInit {
  @Output()
  updateFilterEvent: EventEmitter<CalendarFilter> = new EventEmitter();

  countryString = 'All countries';
  topicString = 'All topics';

  allTopicGroups: CalendarEventType[];
  allCountries: Country[];
  _filter: CalendarFilter;

  @Input()
  get filter(): CalendarFilter {
    return this._filter;
  }
  set filter(f: CalendarFilter) {
    this._filter = f;
    if (this._filter.countries?.length) {
      const names = this._filter.countries.map((c) => c.name);
      this.countryString = this.truncateList(names);
    } else {
      this.countryString = 'All countries';
    }
    if ((this._filter.topicGroups?.length) && (this._filter.topicGroups?.length !== this.allTopicGroups.length)) {
      const topicNames = this._filter.topicGroups.map((t) => t.name);
      topicNames.sort();
      this.topicString = this.truncateList(topicNames);
    } else {
      this.topicString = 'All topics';
    }
  }

  private truncateList(names: string[], max = 3): string {
    if (names.length <= max) {
      return names.join(', ');
    }
    return names.slice(0, max).join(', ') + ` (+${names.length - max} more)`;
  }

  editFilter() {
    if (!this.allCountries || !this.allTopicGroups) {
      return;
    }
    let dialogRef = this.dialog.open(CalendarFilterPopupComponent, {
      minWidth: '400px',
      data: {
        allCountries: this.allCountries,
        selectedCountries: this.filter?.countries?.length ? [...this.filter.countries] : [...this.allCountries],
        allTopicGroups: this.allTopicGroups,
        selectedTopicGroups: (!this._filter?.topicGroups || !this._filter?.topicGroups.length) ? this.allTopicGroups : this._filter.topicGroups,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const countries = result.selectedCountries.length === this.allCountries.length ? [] : result.selectedCountries;
          this.filter = new CalendarFilter(
            countries,
            result.selectedTopicGroups.length !== this.allTopicGroups.length ? result.selectedTopicGroups : []);
          this.updateFilterEvent.emit(this.filter);
        }
        return false;
      });
  }

  constructor(
    public dialog: MatDialog,
    public countryService: CountryService,
    public calendarService: CalendarService
  ) { }

  ngOnInit(): void {
    this.countryService
      .userCountries()
      .pipe(take(1))
      .subscribe({
        next: (c: Country[]) => (this.allCountries = c),
      });
    this.calendarService
      .getCalendarEventTypes()
      .pipe(take(1))
      .subscribe({
        next: (c: CalendarEventType[]) => (this.allTopicGroups = c),
      });
  }
}
